import { render, staticRenderFns } from "./setbet.vue?vue&type=template&id=2711dc30&scoped=true&"
import script from "./setbet.vue?vue&type=script&lang=js&"
export * from "./setbet.vue?vue&type=script&lang=js&"
import style0 from "./setbet.vue?vue&type=style&index=0&id=2711dc30&scoped=true&lang=css&"
import style1 from "./setbet.vue?vue&type=style&index=1&id=2711dc30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2711dc30",
  null
  
)

export default component.exports